export enum ViewModes {
    WithPrice = 2,
    Favorites = 3
}
